// src: https://stackoverflow.com/a/35375045/3670829
export var hasWindow = function () { return typeof window !== 'undefined'; };
// src: https://github.com/airbnb/lottie-web/issues/440#issuecomment-338057030
export var hasNavigator = function () { return typeof navigator !== 'undefined'; };
export var hasDocument = function () { return typeof document !== 'undefined'; };
